export default __webpack_public_path__ + "static/media/ralph-ravi-kayden-vbSRUrNm3Ik-unsplash.78b36777.jpg";